import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CTAButton } from './CTAButton';
const items = [{
  name: 'Tomo 1 — El Interruptor',
  value: '$5.990'
}, {
  name: 'Tomo 2 — Ingeniería de Guion',
  value: '$5.990'
}, {
  name: 'Tomo 3 — El Vacío Cuántico',
  value: '$5.990'
}, {
  name: 'Tomo 4 — El Cuerpo Magnético',
  value: '$5.990'
}, {
  name: 'Tomo 5 — El Guardián del Sueño',
  value: '$5.990'
}, {
  name: 'Bono 1 — El Radar de Sincronías',
  value: '$3.990'
}, {
  name: 'Bono 2 — Guiones de Auto-Hipnosis',
  value: '$3.990'
}, {
  name: 'Bono 3 — El Plan de 21 Días',
  value: '$3.990'
}];
export function ValueStackSection() {
  return <SectionWrapper bgColor="bg-brand-dark" data-id="element-231">
      <h2 className="font-heading text-2xl md:text-3xl text-brand-ivory text-center font-semibold" data-id="element-232">
        Lo que recibís hoy:
      </h2>

      <div className="mt-10 max-w-xl mx-auto" data-id="element-233">
        <div className="border border-brand-gold/15 rounded-xl overflow-hidden" data-id="element-234">
          {items.map((item, i) => <div key={i} className={`flex items-center justify-between px-5 py-3.5 ${i % 2 === 0 ? 'bg-white/[0.02]' : 'bg-transparent'}`} data-id="element-235">
              <span className="text-brand-ivory/80 font-body text-sm md:text-base" data-id="element-236">
                {item.name}
              </span>
              <span className="text-brand-gold font-body font-semibold text-sm md:text-base shrink-0 ml-4" data-id="element-237">
                {item.value}
              </span>
            </div>)}
          <div className="flex items-center justify-between px-5 py-4 bg-brand-gold/10 border-t border-brand-gold/20" data-id="element-238">
            <span className="text-brand-ivory font-body font-bold text-base md:text-lg" data-id="element-239">
              VALOR TOTAL
            </span>
            <span className="text-brand-gold font-heading font-bold text-lg md:text-xl" data-id="element-240">
              $41.920
            </span>
          </div>
        </div>
      </div>

      <div className="mt-14 text-center space-y-3" data-id="element-241">
        <p className="text-brand-muted font-heading text-xl md:text-2xl" data-id="element-242">
          Hoy no pagás $41.920
        </p>
        <p className="text-brand-muted font-heading text-xl md:text-2xl" data-id="element-243">
          Ni $29.990
        </p>
        <p className="text-brand-muted font-heading text-xl md:text-2xl" data-id="element-244">
          Ni $24.990
        </p>
      </div>

      <div className="mt-10 text-center" data-id="element-245">
        <p className="font-heading text-5xl md:text-7xl text-brand-gold font-bold" style={{
        textShadow: '0 0 40px rgba(212,175,55,0.3)'
      }} data-id="element-246">
          Solo $19.990
        </p>
        <p className="text-brand-ivory/80 font-body text-lg mt-4" data-id="element-247">
          Acceso inmediato a las 390 páginas del sistema completo
        </p>
      </div>

      <div className="mt-12" data-id="element-248">
        <CTAButton text="→ SÍ, QUIERO EL SISTEMA COMPLETO POR $19.990" data-id="element-249" />
      </div>
    </SectionWrapper>;
}